import React, { useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';

import { CREATE_ACCESS_TOKEN } from './queries';
import { FullToken } from './Token';

const FIELDS = {
  dealerId: {
    label: 'Dealer',
    clientSelect: 'activeDealers',
    oneOption: 'no-choice',
    rules: { required: true },
  },
  name: {
    hint: 'Optional. A name or tag for this token, for your reference'
  },
};

const NewAccessToken = ({ setShow, refetch }) => {
  const [accessToken, setAccessToken] = useState();

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createAccessToken] = useMutation(CREATE_ACCESS_TOKEN, {
    onCompleted: data => {
      setAccessToken(data.createAccessToken.accessToken);
      refetch();
    }
  });

  const onSubmit = input => {
    createAccessToken({ variables: prepareInput(input, FIELDS) });
  };

  return (
    <Modal title="Generate API Access Token" setShow={setShow}>
      {accessToken ? (
        <View style={{ gap: 12 }}>
          <Text>
            Your token has been generated. Please save it now. You can view it
            for 24 hours.
          </Text>

          <FullToken accessToken={accessToken} />
        </View>
      ) : (
        <>
          <Fields
            fields={FIELDS}
            control={control}
            errors={errors}
            setValue={setValue}
          />

          <Button label="Generate" onPress={handleSubmit(onSubmit)} wide />
        </>
      )}
    </Modal>
  );
};

export default NewAccessToken;
